import './Tabs.scss';

export interface TabsProps<T extends string = string> {
  tabs: Array<{
    id: T;
    label: string;
  }>;
  activeTab: T;
  onTabChange: (tabId: T) => void;
}

export const Tabs = <T extends string = string>({
  tabs,
  activeTab,
  onTabChange,
}: TabsProps<T>): JSX.Element => {
  return (
    <div className="tabs">
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className={`tabs__item ${activeTab === tab.id ? 'active' : ''}`}
          onClick={activeTab === tab.id ? undefined : () => onTabChange(tab.id)}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};
